import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { faBell, faFileExcel, faHome, faStar } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'app/shared/models/class/nav/nav-link';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  faHome = faHome;
  faBell = faBell;
  faStar = faStar;
  faFileExcel = faFileExcel;

  navLinks: NavLink[] = [
    new NavLink('/admin/ratings', 'Ratings', 'Vote du public', this.faStar),
  ];

  navLinksSA: NavLink[] = [
    new NavLink('/admin/home', 'Accueil', '', this.faHome),
    new NavLink('/admin/push', 'Notifications', 'Gérer les notifications', this.faBell),
    new NavLink('/admin/rating', 'Votes', 'Gérer les votes', this.faStar),
    new NavLink('/admin/export', 'Newsletters', 'Exporter la liste des mails utilisateurs', this.faFileExcel),
    new NavLink('/admin/ratings', 'Ratings', 'Vote du public', this.faStar),
    new NavLink('/admin/exportAnswer', 'Answers', 'Exporter la liste des réponses à la question subsidiaire', this.faFileExcel),

  ];

  constructor() {
  }

}
